import React, { useState } from "react";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { apiSlice } from "../util/apiSlice";
import ConfirmSubmitButton from "./ConfirmSubmitButton";

export default function SuperBowlScore({ userData }) {
  const [score, setScore] = useState(userData.sbScore || 0);
  const userScore =
    userData && userData.sbScore ? userData.sbScore.toString() : "0";
  const min = 0.1;
  const max = 99.9;

  const handleScoreChange = (event) => {
    let newScore = event.target.value.replace(/^0+/, "");
    if (!newScore) {
      setScore("");
      return;
    }
    newScore = Math.round(newScore * 10) / 10;
    newScore = Math.max(Math.min(newScore, max), min);
    setScore(newScore);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="h5" pt={5}>
        What's the total score going to be in the Super Bowl?
      </Typography>
      <Typography gutterBottom pt={5} sx={{ paddingTop: 1 }}>
        Accuracy to the tenth of a point will be used as tie breaker (.0 not
        allowed. The tenth has to be 1-9)
      </Typography>
      <TextField
        sx={{
          width: 280,
        }}
        type="number"
        inputProps={{
          step: 0.1,
          min: min,
          max: max,
        }}
        onChange={handleScoreChange}
        value={score}
        onKeyDown={(e) => {
          if (
            e.key === "e" ||
            e.key === "E" ||
            e.key === "-" ||
            e.key === "+"
          ) {
            e.preventDefault();
          }
        }}
        error={score % 1 === 0}
        helperText={score % 1 === 0 ? "Score cannot end in .0" : ""}
      />
      <ConfirmSubmitButton
        data={score}
        postTo="/update-sb-score"
        what="Super Bowl score"
        mutationHook={apiSlice.useSetNewDataAndReloadUserDataMutation}
        variant="contained"
        sx={{ width: 280, ml: 0 }}
        disabled={(userData.sbScore && userScore === score) || score % 1 === 0}
      />
    </Box>
  );
}
